module.exports = __webpack_public_path__ + "static/media/background.eb8794e4.png";